import { BaseHttpError } from 'core/services/api/errors';
import { AlbumPhotosResponse } from 'core/services/api/response-types';
import { AlbumPhoto } from 'core/types';
import { albumPhotoKeys } from 'core/utils/query-key-factory';
import { useServices } from 'core/services';
import { getPageParams } from 'core/utils/pagination';
import { useInfiniteQuery, InfiniteData } from '@tanstack/react-query';
import { photoWithParams } from 'core/utils/request-with-params';

export const useGetAlbumPhotos = (albumId: string) => {
	const { api, authentication } = useServices();

	const isLoggedIn = authentication.isAuthenticated();

	const albums = useInfiniteQuery<
		AlbumPhotosResponse,
		BaseHttpError,
		InfiniteData<AlbumPhoto[]>
	>({
		queryKey: albumPhotoKeys.list(albumId),
		queryFn: ({ pageParam = undefined, signal }) => {
			return api.getAlbumPhotos(albumId, {
				pagination: {
					...(pageParam as any),
					with: photoWithParams,
				},
				signal,
			});
		},
		initialPageParam: undefined,
		enabled: !!albumId && isLoggedIn,
		select: response => {
			return {
				pages: response.pages.map(page => page.data),
				pageParams: response.pageParams,
			};
		},
		getPreviousPageParam: firstPage =>
			getPageParams(firstPage.pagination).previousParam,
		getNextPageParam: lastPage =>
			getPageParams(lastPage.pagination).nextParam,
		refetchOnMount: true,
	});

	return albums;
};
